import React, { FunctionComponent } from 'react';
import ReactModal from 'react-modal';
import Media from 'react-media';
import styled from 'styled-components';

import { SCREEN } from 'scenes/common/types/screen';

import { Banner, Heading, Button, Text } from './chroma';

export interface ModalProps {
  header: string;
  content?: string;
  isOpen: boolean;
  onClose: () => void;
  ImageComponent: FunctionComponent;
}

const BannerWrapper = styled.div`
  .c-banner {
    height: 97px;
  }
`;

const ContentWrapper = styled.div`
  padding: 0 40px;
  margin: 26px 0;
`;

export const ErrorModal: FunctionComponent<ModalProps> = ({
  header,
  content,
  isOpen,
  onClose,
  ImageComponent,
}) => (
  <Media query={{ maxWidth: SCREEN.MEDIUM }}>
    {() => (
      <ReactModal
        isOpen={isOpen}
        onRequestClose={onClose}
        contentLabel={header}
        style={{
          content: {
            top: '15%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            width: '40rem',
            maxWidth: '90%',
            maxHeight: '80%',
            transform: 'translate(-50%)',
            fontSize: '1.2rem',
            borderRadius: '0.3rem',
            padding: 0,
          },
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, .6)',
            zIndex: 1000,
          },
        }}
        ariaHideApp={false}
      >
        <BannerWrapper>
          <Banner>
            <ImageComponent />
          </Banner>
        </BannerWrapper>
        <ContentWrapper>
          <Heading size={3}>{header}</Heading>
          {content && <Text>{content}</Text>}
          <Button primary maxWidth onClick={onClose}>
            Retry
          </Button>
        </ContentWrapper>
      </ReactModal>
    )}
  </Media>
);

export default ErrorModal;
